import STORY from "./story";

export default STORY;
